module.exports = __webpack_public_path__ + "static/laura_03-57da2c4d6a3d4371bcd91d15b734f330.jpg";